import { auth } from '../firebase';
import { getRuntimeConfig } from '../runtimeConfig';

export function getAdminEmails() {
  return getRuntimeConfig('ADMIN_EMAILS', '').split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
}

export function isAdminEmail(email) {
  if (!email) {
    return false;
  }
  return getAdminEmails().includes(email.trim().toLowerCase());
}

async function adminFetch(path, options = {}) {
  const token = await auth.currentUser?.getIdToken();
  if (!token) {
    throw new Error('You must be logged in to use the admin API.');
  }

  const response = await fetch(path, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : null;
  if (!response.ok) {
    throw new Error(payload?.error || `Admin API request failed: ${response.status}`);
  }
  return payload;
}

export async function loadAdminSessions() {
  return adminFetch('/admin/api/sessions');
}

export async function loadAdminCourses() {
  return adminFetch('/admin/api/courses');
}

export async function loadAdminScenarios() {
  return adminFetch('/admin/api/scenarios');
}

export async function loadAdminTests() {
  return adminFetch('/admin/api/tests');
}

export async function loadTests() {
  return adminFetch('/tests-data');
}

export async function upsertAdminCourse(courseJson) {
  return adminFetch('/admin/api/courses', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: courseJson,
  });
}

export async function upsertAdminScenario(scenarioJson) {
  return adminFetch('/admin/api/scenarios', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: scenarioJson,
  });
}

export async function upsertAdminTest(testJson) {
  return adminFetch('/admin/api/tests', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: testJson,
  });
}

export async function updateCourseEnabled(courseId, enabled) {
  return adminFetch(`/admin/api/courses/${encodeURIComponent(courseId)}/enabled`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ enabled }),
  });
}

export async function updateScenarioEnabled(scenarioId, enabled) {
  return adminFetch(`/admin/api/scenarios/${encodeURIComponent(scenarioId)}/enabled`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ enabled }),
  });
}

export async function updateTestEnabled(testId, enabled) {
  return adminFetch(`/admin/api/tests/${encodeURIComponent(testId)}/enabled`, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ enabled }),
  });
}

export async function loadDemoSetting() {
  return adminFetch('/admin/api/settings/demo');
}

export async function updateDemoSetting(enabled) {
  return adminFetch('/admin/api/settings/demo', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ enabled }),
  });
}
